export function withServerContext(callback) {
    return callback();
}

function serverOnly() {
    throw new Error('expo-font server-only context cannot be used in the browser.');
}

export {
    serverOnly as addServerFont,
    serverOnly as getLoadedServerFonts,
    serverOnly as isServerFontLoaded,
    serverOnly as getServerResourceDescriptors,
};
